








































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'
import UpdateCollectionMemoCollectionInfo from '@/components/organisms/UpdateCollectionMemoCollectionInfo/UpdateCollectionMemoCollectionInfo.vue'
import {
  UpdateMemoInputInfo,
  UpdateMemoInputInfoItem,
  defaultUpdateMemoInputInfoItem
} from '@/components/organisms/UpdateMemoInputInfo'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  collectionApi,
  CollectionMemo,
  defaultCollectionMemo,
  defaultSimpleBibliographyReal,
  defaultSystemCode,
  ErrorMessage,
  SimpleBibliographyReal
} from '@/api'
import { UpdateCollectionMemoCollectionInfoItem } from '@/components/organisms/UpdateCollectionMemoCollectionInfo/index.type'
import { CODE_KEY } from '@/config'
import {
  alertStore,
  modalErrorStore,
  modalUpdateCollectionMemoStore,
  systemCodeStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import { AlertCodeALC00002, SearchType } from '@/types'
import { BibliographyRealInfoMagazine } from '@/components/organisms/BibliographyRealInfoMagazine'
import { UpdateMemoBibliographyInfo } from '@/components/organisms/UpdateMemoBibliographyInfo'

@Component({
  components: {
    UpdateMemoBibliographyInfo,
    BibliographyRealInfoMagazine,
    UpdateMemoInputInfo,
    UpdateCollectionMemoCollectionInfo,
    ModalFooter
  }
})
export default class ModalUpdateCollectionMemo extends ComponentVue {
  simpleBibliographyReal: SimpleBibliographyReal = defaultSimpleBibliographyReal()

  collectionMemo: CollectionMemo = defaultCollectionMemo()

  collectionMemoInputItem: UpdateMemoInputInfoItem = defaultUpdateMemoInputInfoItem()

  get isMagazine(): boolean {
    return this.simpleBibliographyReal.searchType.code === SearchType.Magazine
  }

  get isOpen(): boolean {
    return modalUpdateCollectionMemoStore.isOpen
  }

  get bibliographyRealId(): number {
    return modalUpdateCollectionMemoStore.bibliographyRealId
  }

  get collectionId(): number {
    return modalUpdateCollectionMemoStore.collectionId
  }

  get collectionInfoItem(): UpdateCollectionMemoCollectionInfoItem {
    return {
      collectionNo: this.collectionMemo.collectionNo,
      holdingBranchCode: this.collectionMemo.holdingBranchCode,
      callNumber: this.collectionMemo.callNumber,
      shelfType: this.collectionMemo.shelfType,
      collectionType: this.collectionMemo.collectionType,
      status: this.collectionMemo.status,
      handlingType: this.collectionMemo.handlingType,
      appendixCode: this.collectionMemo.appendixCode,
      updatedTime: this.collectionMemo.updatedTime,
      updatedBranchCode: this.collectionMemo.updatedBranchCode,
      forwardingBranchCode: this.collectionMemo.forwardingBranchCode,
      userId: this.collectionMemo.userId
    }
  }

  @Watch('isOpen')
  initialize(newVal: boolean): void {
    if (newVal) {
      systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.COLLECTION_MEMO.KEY])

      this.getSimpleBibliographyReal()
      this.callApiGetCollectionMemo()
      return
    }

    this.simpleBibliographyReal = defaultSimpleBibliographyReal()
    this.collectionMemo = defaultCollectionMemo()
    this.collectionMemoInputItem = defaultUpdateMemoInputInfoItem()
  }

  onClickCancel(): void {
    const alert: Alert = AlertFactory.create(AlertCodeALC00002)
    alertStore.setItem(alert)

    this.$modalAlert.open({
      onOkClick: modalUpdateCollectionMemoStore.close
    })
  }

  onClickPrint(): void {
    const element = document.getElementById('modal-update-collection-memo')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async getSimpleBibliographyReal(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.simpleBibliographyReal = await bibliographyRealApi.getSimpleBibliographyReal(
        this.bibliographyRealId
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async callApiGetCollectionMemo(): Promise<void> {
    try {
      this.collectionMemo = await collectionApi.getCollectionMemoById({
        collectionId: this.collectionId
      })
      this.collectionMemoInputItem = {
        workMemoCode: '',
        workMemo: this.collectionMemo.workMemo,
        workMemoTime: this.collectionMemo.workMemo
          ? this.collectionMemo.workMemoTime
          : '',
        workMemoBranchCode: this.collectionMemo.workMemo
          ? this.collectionMemo.workMemoBranchCode
          : defaultSystemCode(),
        displayMemoCode: '',
        displayMemo: this.collectionMemo.displayMemo,
        displayMemoTime: this.collectionMemo.displayMemo
          ? this.collectionMemo.displayMemoTime
          : '',
        displayMemoBranchCode: this.collectionMemo.displayMemo
          ? this.collectionMemo.displayMemoBranchCode
          : defaultSystemCode(),
        localMemoCode: '',
        localMemo: this.collectionMemo.localMemo,
        localMemoTime: this.collectionMemo.localMemo
          ? this.collectionMemo.localMemoTime
          : '',
        localMemoBranchCode: this.collectionMemo.localMemo
          ? this.collectionMemo.localMemoBranchCode
          : defaultSystemCode()
      }
    } catch (error) {
      modalUpdateCollectionMemoStore.close()
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async callApiUpdateCollectionMemo(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await collectionApi.updateCollectionMemo({
        id: this.collectionMemo.id,
        workMemo: this.collectionMemoInputItem.workMemo,
        displayMemo: this.collectionMemoInputItem.displayMemo,
        localMemo: this.collectionMemoInputItem.localMemo,
        revision: this.collectionMemo.revision
      })
      modalUpdateCollectionMemoStore.updated({
        workMemo: this.collectionMemoInputItem.workMemo,
        displayMemo: this.collectionMemoInputItem.displayMemo,
        localMemo: this.collectionMemoInputItem.localMemo
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }
}
